<template>
  <div
    class="headerContainer"
    :class="{
      isShowWhite: isShowWhite,
      header_hidden: isShowHidden,
      header_visible: !isShowHidden,
    }"
  >
    <div class="wrapper navbar">
      <router-link to="/" class="logo">
        <img src="@/assets/imgs/common/logo.png" alt="多点美好" />
        <!-- <span class="navbarName">多点美好</span> -->
      </router-link>

      <div class="navbarMenu">
        <router-link
          v-for="item in routesList"
          :key="item.path"
          :to="item.path"
          class="navbarMenuItem"
        >
          {{ item.name }}
        </router-link>
        <a
          v-for="item in externalLinks"
          :key="item.url"
          :href="item.url"
          target="_blank"
          class="navbarMenuItem"
        >
          {{ item.name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  data() {
    return {
      isShowHidden: false, // 是否隐藏导航栏
      lastScrollY: 0, // 记录上次滚动位置
      isShowWhite: false,
      routesList: [
        { path: "/about", name: "关于我们" },
        { path: "/growthCare", name: "成长关怀" },
        { path: "/companyCulture", name: "我们的文化" },
        // { path: '/jobVacancy', name: '招聘职位' },
      ],
      externalLinks: [
        {
          url: "https://www.zhipin.com/gongsi/job/3402ab67194d2e271nB42Ny5GQ~~.html?ka=company-jobs",
          name: "招聘职位",
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isShowWhite = window.scrollY >= 200;

      const currentScrollY = window.scrollY;
      // 向下滚动且滚动距离大于100px时隐藏
      if (currentScrollY > this.lastScrollY && currentScrollY > 100) {
        this.isShowHidden = true;
      }
      // 向上滚动时显示
      else if (currentScrollY < this.lastScrollY) {
        this.isShowHidden = false;
      }
      this.lastScrollY = currentScrollY;
    },
  },
};
</script>

<style scoped lang="scss" src="@/assets/styles/pc/header.scss"></style>
<style lang="scss"></style>
